import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-change-icon",
  "use": "icon-change-icon-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-change-icon\"><g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><path d=\"M2.03 6.574A10 10 0 0111 1c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.984 9.984 0 01-7.936-3.914\" stroke=\"#333\" /><path stroke=\"#CF001F\" d=\"M5.97 7.641l-4.96.011L1 2.704\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol